import VueRouter from 'vue-router';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { cliente } from '@/common/mock/clientes';

@Component({})
export class Showcase extends Vue {

    public route: any               = new VueRouter({mode: 'history'});
    public slug: string             = '';
    public produto: object          = {};
    public exibeModal: boolean      = false;
    private mock: any               = [];
    
    created(){
        this.checkSlugClient(this.$route.params.slug);
    }

    private checkSlugClient(slug: string){
        if( cliente[slug] ){
            this.slug = this.$route.params.slug;
            this.mock = cliente[slug];
        }else{
            this.$router.push('/404')
        }
    }

    public abreModalProduto(e:any){
        this.exibeModal = true;
        this.produto    = e;
    }

    public actionModal(e:boolean){
        this.exibeModal = e;
    }

}